



















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user/user.store';
import { Role } from '@/core/security/Role';
import Reactions from '@/components/frontpage/reactions/Reactions.vue';

import breakpointsStateObservable from '@/core/responsive/breakpointsState.observable';
import {
    ReactionType, BugTrackerIssueCommentViewObject, BugTrackerIssueRemoveCommentRequest, BugTrackerIssueUpdateCommentRequest
} from '@/types/apiServerContract';
import { BugTrackerModule } from '@/store/modules/bugtracker/bugtracker.store';

@Component({
    components: { Reactions }
})
export default class BugTrackerDetailsComment extends Vue {
	@Prop({ required: true }) comment!: BugTrackerIssueCommentViewObject;
	@Prop({ type: Boolean }) isLoggedIn!: boolean;

	editMode: boolean = false;
	internalComment: string = this.comment.comment;

	get isCommentOwner() {
	    return UserModule.user?.HasRole([Role.Administrator, Role.SuperAdmin]) || this.comment.author === UserModule.user?.id;
	}

	get isPhoneView() {
	    return breakpointsStateObservable.isBreakpointActive('max-md');
	}

	get commentAvatarSize() {
	    return this.isPhoneView ? 40 : 50;
	}

	async deleteComment() {
	    const check = await this.$bvModal.msgBoxConfirm('Are you sure you wish to delete this comment?', {
	        centered: true,
	        okTitle: 'Yes'
	    });
	    if (!check) return;

	    const request: BugTrackerIssueRemoveCommentRequest = {
	        commentId: this.comment.id,
	        issueId: this.comment.issueId
	    };

	    try {
	        await BugTrackerModule.removeComment(request);
	    } finally {
	    }

	    this.$bvToast.toast('Comment deleted successfully', {
	        variant: 'success',
	        title: 'Success'
	    });
	}

	async editComment() {
	    const check = await this.$bvModal.msgBoxConfirm('Are you sure you wish to edit this comment?', {
	        centered: true,
	        okTitle: 'Yes'
	    });
	    if (!check) return;

	    const request: BugTrackerIssueUpdateCommentRequest = {
	        issueId: this.comment.issueId,
	        comment: this.internalComment,
	        commentId: this.comment.id
	    };

	    try {
	        await BugTrackerModule.updateComment(request);
	    } finally {
	    }

	    this.$bvToast.toast('Comment edited successfully', {
	        variant: 'success',
	        title: 'Success'
	    });

	    this.editMode = false;
	}

	toggleEdit(state: boolean) {
	    this.internalComment = this.comment.comment;
	    this.editMode = state;
	}

	async reacted(data: { type: ReactionType; active: boolean }) {
	    // const request: NewsCommentReactionRequest = {
	    //     type: data.type,
	    //     commentId: this.comment.id,
	    //     newsId: this.comment.newsId,
	    //     active: data.active
	    // };

	    // await NewsModule.NewsCommentReaction(request);
	}
}
